export { RAPIDAPI_KEY } from './credentials';
export const url = 'https://cbad.p.rapidapi.com';
export const BASE_URL = 'https://api.cbad.xyz';
export const RAPIDAPI_PROJECT_PAGE = 'https://rapidapi.com/chrisgraneyward-Cf0g1vby6xt/api/cbad'
export const RAPIDAPI_HOST = 'cbad.p.rapidapi.com';
